<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="View Coupon"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Coupon' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <b-card>
          <div v-if="isLoading" class="text-center py-4">Loading coupon details...</div>
          <div v-else-if="loadError" class="text-center py-4 text-danger">
            {{ loadError }}
          </div>
          <template v-else>
            <b-row>
              <b-col cols="12" sm="12" md="4">
                <div class="form-group">
                  <label for="promoCode">Coupon Code</label>
                  <b-form-input id="promoCode" disabled inputType="text" :value="displayValue(details.promoCode)" />
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="4">
                <div class="form-group">
                  <label for="categoryOptions">Applicable On</label>
                  <b-form-input id="categoryOptions" disabled type="text" :value="displayValue(details.promoRules.applicableOn)" />
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="4" v-if="details.promoRules.applicableOn === 'CATALOG' || details.promoRules.applicableOn === 'ITEM'">
                <div class="form-group">
                  <label for="catalogName">Catalog</label>
                  <b-form-input id="catalogName" disabled type="text" :value="displayValue(details.catalogName || details.promoRules.catalogId)" />
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="4" v-if="details.promoRules.applicableOn === 'ITEM'">
                <div class="form-group">
                  <label for="itemName">Item</label>
                  <b-form-input id="itemName" disabled type="text" :value="displayValue(details.itemName || details.promoRules.itemId)" />
                </div>
              </b-col>
              <b-col cols="12" sm="12" md="4" v-if="details.promoRules.applicableOn === 'PARTNER'">
                <div class="form-group">
                  <label for="partnerName">Partner</label>
                  <b-form-input id="partnerName" disabled type="text" :value="displayValue(details.partnerName || details.promoRules.providerId)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="4">
                <div class="form-group">
                  <label for="title">Title</label>
                  <textarea id="title" rows="4" cols="30" class="form-control" disabled :value="displayValue(details.title)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="description">Description</label>
                  <textarea id="description" rows="4" cols="30" class="form-control" disabled :value="displayValue(details.description)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="startdate">Start Date</label>
                  <b-input id="startdate" disabled type="text" :value="displayDate(details.promoRules.startDate)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="enddate">End Date</label>
                  <b-input id="enddate" disabled type="text" :value="displayDate(details.promoRules.endDate)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="maxRewardValue">Max Reward Value</label>
                  <b-form-input id="maxRewardValue" disabled inputType="text" :value="displayValue(details.promoRules.maxRewardValue)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="minimumAmountExcludingTax">Minimum Amount Excluding Tax</label>
                  <b-form-input id="minimumAmountExcludingTax" disabled inputType="text" :value="displayValue(details.promoRules.minimumAmountExcludingTax)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="rewardValue">{{ details.promoRules.discountType === "Percentage" ? "Reward Percentage" : "Reward Value" }}</label>
                  <b-form-input id="rewardValue" disabled inputType="text" :value="displayValue(details.promoRules.rewardValue)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="within">Frequency in minutes</label>
                  <b-form-input id="within" disabled inputType="text" :value="displayValue(details.timingRules.within)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="discountType">Discount Type</label>
                  <b-form-input id="discountType" disabled type="text" :value="displayValue(details.promoRules.discountType)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="rewardType">Reward Type</label>
                  <b-form-input id="rewardType" disabled type="text" :value="displayValue(details.promoRules.rewardType)" />
                </div>
              </b-col>
              <b-col md="4" v-if="details.promoRules.rewardType === 'Wallet'">
                <div class="form-group">
                  <label for="rewardBalanceType">Reward Balance Type</label>
                  <b-form-input id="rewardBalanceType" disabled type="text" :value="displayValue(details.promoRules.wallet && details.promoRules.wallet.amountType ? details.promoRules.wallet.amountType.value : '')" />
                </div>
              </b-col>
            </b-row>
            <b-row v-if="details.promoRules.rewardType === 'Wallet'">
              <b-col md="4">
                <div class="form-group">
                  <label for="expiryValue">Enter Expiry</label>
                  <b-form-input id="expiryValue" disabled inputType="number" :value="displayValue(details.promoRules.wallet && details.promoRules.wallet.expireIn ? details.promoRules.wallet.expireIn.value : '')" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="uom">UOM</label>
                  <b-form-input id="uom" disabled inputType="text" :value="displayValue(details.promoRules.wallet && details.promoRules.wallet.expireIn ? details.promoRules.wallet.expireIn.uom : '')" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <div class="form-group">
                  <label for="totalLimit">Total allowed in day</label>
                  <b-form-input id="totalLimit" disabled inputType="text" :value="displayValue(details.timingRules.totalLimit)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="maxExisting">Max Existing Orders</label>
                  <b-form-input id="maxExisting" disabled inputType="text" :value="displayValue(details.promoRules.maxExistingOrders)" />
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <label for="minExisting">Min Existing Orders</label>
                  <b-form-input id="minExisting" disabled inputType="text" :value="displayValue(details.promoRules.minExistingOrders)" />
                </div>
              </b-col>
              <b-col md="12">
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="maximumQuantity">Maximum Quantity</label>
                      <b-form-input id="maximumQuantity" disabled inputType="text" :value="displayValue(details.promoRules.maxQuantity)" />
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="minimumQuantity">Minimum Quantity</label>
                      <b-form-input id="minimumQuantity" disabled inputType="text" :value="displayValue(details.promoRules.minQuantity)" />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="12" v-if="details.locationRules && (details.locationRules.city || details.locationRules.state)">
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label>Location</label>
                      <b-form-input disabled inputType="text" :value="details.locationRules.city ? 'City' : 'State'" />
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label>Location Value</label>
                      <b-form-input disabled inputType="text" :value="displayValue(details.locationRules.city || details.locationRules.state)" />
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="4" v-for="(terms, idx) in termsList" :key="idx">
                <div class="form-group">
                  <label for="tc">Terms and Conditions</label>
                  <textarea id="tc" rows="4" cols="30" class="form-control" disabled :value="displayValue(terms)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="12" md="4">
                <div class="form-group">
                  <b-form-checkbox switch disabled :checked="!!details.allowMultiDiscount">Allow MultiDiscount</b-form-checkbox>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <b-form-checkbox switch disabled :checked="!!details.promote">Promote</b-form-checkbox>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-group">
                  <b-form-checkbox switch disabled :checked="!!details.autoApply">AutoApply</b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";

export default {
  name: "ViewCoupon",
  components: { ComponentHeader },
  data() {
    return {
      isLoading: true,
      loadError: "",
      details: { promoRules: {}, timingRules: {}, tc: [] },
    };
  },
  computed: {
    userRole() {
      return this.$store.getters["auth/getUserRole"] || JSON.parse(sessionStorage.getItem("userLogin"))?.role;
    },
    termsList() {
      return Array.isArray(this.details.tc) && this.details.tc.length ? this.details.tc : ["--"];
    },
  },
  async mounted() {
    await this.loadCouponDetails();
  },
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === "" ? "--" : String(value);
    },
    displayDate(value) {
      if (!value) return "--";
      return moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : "--";
    },
    async loadCouponDetails() {
      this.loadError = "";
      this.isLoading = true;
      try {
        this.details = await this.resolveCouponData();
      } catch (error) {
        this.loadError = error?.message || "Failed to load coupon details.";
      } finally {
        this.isLoading = false;
      }
    },
    async resolveCouponData() {
      const routeData = this.$route.params?.data;
      const routeId = this.$route.params?.id || this.$route.query?.id;
      if (routeData && routeData._id) {
        return { promoRules: {}, timingRules: {}, tc: [], ...routeData };
      }
      if (!routeId) {
        throw new Error("Coupon data not found. Please open this page from coupon list.");
      }
      const coupons = await this.$store.dispatch("coupon/couponCodeList", this.userRole);
      const matched = (Array.isArray(coupons) ? coupons : []).find((coupon) => coupon._id === routeId);
      if (!matched) throw new Error("Invalid coupon ID. Coupon not found.");
      return { promoRules: {}, timingRules: {}, tc: [], ...matched };
    },
  },
};
</script>
